var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Thêm tài khoản ngân hàng",
            "before-close": _vm.handleClose,
            visible: _vm.isAddAccountDialog,
            "show-close": true,
            "close-on-click-modal": false,
            width: "700px",
            top: "20vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isAddAccountDialog = $event
            },
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                "label-width": "140px",
                model: _vm.formData,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Chọn ngân hàng", prop: "brandName" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "500px" },
                      attrs: { placeholder: "Chọn ngân hàng" },
                      model: {
                        value: _vm.formData.brandName,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "brandName", $$v)
                        },
                        expression: "formData.brandName",
                      },
                    },
                    _vm._l(_vm.banks, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.code,
                          attrs: {
                            label: item.full_name + " - " + item.brand_name,
                            value: item.brand_name,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  width: "24px",
                                  height: "24px",
                                  "margin-right": "8px",
                                },
                                attrs: { src: item.logo_path, alt: "logo" },
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(item.full_name) +
                                    " - " +
                                    _vm._s(item.brand_name)
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Tên chủ tài khoản",
                    prop: "account_holder_name",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "500px" },
                    attrs: { placeholder: "Nhập tên chủ tài khoản" },
                    model: {
                      value: _vm.formData.account_holder_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "account_holder_name", $$v)
                      },
                      expression: "formData.account_holder_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Số tài khoản", prop: "account_number" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "500px" },
                    attrs: {
                      placeholder: "Nhập số tài khoản",
                      maxlength: "20",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.account_number,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "account_number", $$v)
                      },
                      expression: "formData.account_number",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Số CMND/CCCD",
                    prop: "identification_number",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "500px" },
                    attrs: {
                      placeholder: "Nhập số CMND/CCCD",
                      maxlength: "100",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.identification_number,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "identification_number", $$v)
                      },
                      expression: "formData.identification_number",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Số điện thoại", prop: "phone_number" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "500px" },
                    attrs: {
                      placeholder: "Nhập số điện thoại",
                      maxlength: "10",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.phone_number,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "phone_number", $$v)
                      },
                      expression: "formData.phone_number",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tên gợi nhớ", prop: "label" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "500px" },
                    attrs: { placeholder: "Nhập tên gợi nhớ" },
                    model: {
                      value: _vm.formData.label,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "label", $$v)
                      },
                      expression: "formData.label",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "medium" },
                  on: { click: _vm.handleClose },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", [_vm._v("Đóng")]),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    disabled: _vm.formData.brand_name === "",
                    loading: _vm.loading.submit,
                    mini: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _c("span", [_vm._v("Tiếp tục")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("TermsOfUseDialog", {
            attrs: {
              bank: _vm.formData,
              isTermsOfUseDialog: _vm.isTermsOfUseDialog,
            },
            on: { closeDialog: _vm.handleClose },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }